import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";

import { createStore } from "redux";

import { Provider } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import rootReducer from "./redux/reducers";

import "./assets/boxicons-2.0.7/css/boxicons.min.css";
import "./assets/css/grid.css";
import "./assets/css/theme.css";
import "./assets/css/button.css";
import "./assets/css/index.css";

import Layout from "./components/layout/Layout";

import { AuthProvider } from "./context/AuthProvider";
import { NetworkStatusIndicator } from "./components/networkStatusIndicator/NetworkStatusIndicator";
import ErrorPage from "./pages/ErrorPage";

const store = createStore(rootReducer);

document.title = "CMS Speaker";

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <ErrorBoundary
        FallbackComponent={ErrorPage}
        // onReset={() => (location.href = "/")}
      >
        <AuthProvider>
          <NetworkStatusIndicator />
          <Layout />
        </AuthProvider>
      </ErrorBoundary>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
